// L'annuaire des personnalités (15 octobre 2026) : la page, ses filtres, ses cartes.
// Le genre d'une personne n'est jamais deviné ; jamais un nombre de mentions.
// Suivre, Suivie, le quota, les institutions et les sigles sont dans `polisCommun`.
export default {
  titre: 'Personnalités',
  sousTitre: {
    total: '{n} personnalités politiques',
    institutions: 'Parlement, Gouvernement, Parlement européen, partis, régions et grandes villes',
    aJour: 'à jour du {date}',
  },
  ajouter: 'Ajouter une personnalité',
  filtres: {
    aria: 'Filtres',
    pays: 'Pays',
    rechercher: 'Rechercher une personnalité',
    placeholder: 'Un nom, une circonscription, un ministère',
    suivies: 'Suivies seulement',
    institution: 'Institution',
    toutes: 'Toutes',
    groupe: 'Groupe',
    // Un même sigle aux deux chambres se distingue par la sienne.
    court: { AN: 'AN', SENAT: 'Sénat' },
  },
  compte: {
    une: 'Une personnalité',
    n: '{n} personnalités',
    uneSur: 'Une personnalité sur {total}',
    nSur: '{n} personnalités sur {total}',
  },
  ordre: 'Par ordre alphabétique',
  grille: 'Les personnalités',
  comptes: 'Ses comptes : ',
  chargement: 'Chargement de l’annuaire…',
  vide: {
    titre: 'Aucune personnalité ne correspond',
    texte: 'Essayez une autre recherche, ou retirez un filtre.',
    aucunSuivi: 'Aucune personnalité suivie pour l’instant. Suivre une personnalité déclenche son écoute, chaque jour.',
    effacer: 'Effacer les filtres',
  },
}
